import React, { FC } from 'react';
import classNames from 'classnames';

const baseOverlay = 'basic-alert-dialog-overlay';
const baseModal = 'basic-alert-dialog-modal';

interface BasicAlertDialogProps {
    className: string;
    title: string;
    description: string;
    btnName: string;
    onClick?: (event: React.MouseEvent<HTMLInputElement>) => void;
}

export const BasicAlertDialog: FC<BasicAlertDialogProps> = ({
    className, title, description, btnName, onClick,
}) => (
    <div
        className={classNames(baseOverlay, className)}
        role="dialog"
        aria-labelledby="dialog1itle"
        aria-describedby="dialogDesc"
    >
        <div className={baseModal}>
            <div id="dialogTitle" className="title">
                {title}
            </div>
            <div id="dialogDesc" className="description">
                {description}
            </div>
            <div className="footer">
                <button type="button" className="od-btn default" onClick={onClick}>
                    {btnName}
                </button>
            </div>
        </div>
    </div>
);
